import React from 'react';
import { IconSpinner, NamedLink, Bubble, VerificationBadges } from '../../../components';
import { createSlug } from '../../../util/urlHelpers';
import { ensureListing } from '../../../util/data';
import { getImprovedLocationText } from '../../../util/misc';
import css from './SectionListings.module.css';

const Card = (props) => {
    const { listing, config, currentUser } = props;
    const currentListing = ensureListing(listing);

    const {
        listingType,
        categoryLevel1,
        buyerProfile,
        sellingPrincipalProfile,
        currency,
        asking_price,
        Budget_Maximum,
    } = currentListing.attributes.publicData || {};

    const isSearch = listingType === 'search';
    const title = currentListing.attributes.title;
    const slug = createSlug(title);
    const id = currentListing.id.uuid;

    const categories = config?.categoryConfiguration?.categories || [];
    const categoryLabel = categories.find(c => c.id == categoryLevel1)?.name;

    const buyerProfileConfig = config?.listing?.listingFields.find(config => config.key === "buyerProfile");
    const sellerProfileConfig = config?.listing?.listingFields.find(config => config.key === "sellingPrincipalProfile");

    let buyerProfileLabel = "Not specified";
    let sellerProfileLabel = "Not specified";

    if (buyerProfileConfig) {
        const selectedOption = buyerProfileConfig.enumOptions.find(option => option.option === buyerProfile);
        buyerProfileLabel = selectedOption ? selectedOption.label : "Not specified";
    };

    if (sellerProfileConfig) {
        const selectedOption = sellerProfileConfig.enumOptions.find(option => option.option === sellingPrincipalProfile);
        sellerProfileLabel = selectedOption ? selectedOption.label : "Not specified";
    };

    const locationText = getImprovedLocationText(currentListing.attributes.publicData);
    const locationTextMaybe = locationText || "Unknown";
    const trimmedTextMaybe = isSearch && locationTextMaybe.length > 25
        ? locationTextMaybe.substring(0, 25) + "..."
        : !isSearch && locationTextMaybe.length > 40
            ? locationTextMaybe.substring(0, 40) + "..."
            : locationTextMaybe;

    const locationSubject = isSearch
        ? "Location preference: "
        : "Location: ";

    return <NamedLink
        className={css.card}
        key={listing?.id?.uuid}
        name="ListingPage"
        params={{ id, slug }}
    >
        {/* return <div
        className={css.card}
        key={listing?.id?.uuid}
    > */}
        <div className={css.header}>
            <Bubble type={listingType} />
            {/* <div className={css.infoBubble}>
                {categoryLabel}
            </div> */}
            <div className={css.dot}>
                <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                </svg>
            </div>
            <div className={css.location}>
                {locationSubject}
                <span className={css.locationInfo}>
                    {/* {!!currentUser || isSearch ? locationTextMaybe : "MEMBERS ONLY"} */}
                    {trimmedTextMaybe}
                </span>
            </div>
        </div>
        <div className={css.cardTitle}>
            {title}
        </div>
        <div className={css.footerLine}>
            {isSearch ? <div className={css.cardPrice}>
                Budget: {Budget_Maximum?.toLocaleString()} {currency}
            </div> : <div className={css.cardPrice}>
                Asking price: {asking_price ? `${asking_price.toLocaleString()} ${currency}` : "Undisclosed"}
            </div>}
            <div className={css.dot}>
                <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                </svg>
            </div>
            <div className={css.verificationBadges}>
                <VerificationBadges user={currentListing.author} />
            </div>
        </div>
        {/* </div> */}
    </NamedLink>
};

const SectionListings = (props) => {
    const {
        queryListingsInProgress,
        queryListingsError,
        sellListings,
        searchListings,
        config,
        currentUser,
        viewport,
    } = props;

    if (sellListings.length == 0 && searchListings.length == 0 && !queryListingsInProgress) {
        return null;
    };

    const MAX_MOBILE_SCREEN_WIDTH = 768;
    const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;

    const arrays = isMobileLayout
        ? [
            sellListings.slice(0, 3),
            searchListings.slice(0, 3),
            sellListings.slice(3, 6),
            searchListings.slice(3, 6),
            sellListings.slice(6, 9),
            searchListings.slice(6, 9),
        ]
        : [
            sellListings.slice(0, 5),
            searchListings.slice(0, 5),
            sellListings.slice(5, 10),
            searchListings.slice(5, 10),
        ];

    return <div className={css.root}>
        <div className={css.leftShadow} />
        {queryListingsInProgress ? <IconSpinner /> : <div className={css.grid}>
            {arrays.map((array, i) => {
                const rowClass = `r${i + 1}`;
                return <div key={i} className={`${css.row} ${css[rowClass]}`}>
                    {array.map(ls => {
                        return <Card
                            key={ls.id.uuid}
                            listing={ls}
                            config={config}
                            currentUser={currentUser}
                        />
                    })}
                </div>
            })}
        </div>}
        <div className={css.rightShadow} />
    </div>
};

export default SectionListings;
